module.exports = __webpack_public_path__ + "img/Aura_trails.8efadfcb.png";